"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Image_1 = require("office-ui-fabric-react/lib/Image");
var url_1 = require("url");
var getPackageBaseUrl_1 = require("owa-session-store/lib/actions/getPackageBaseUrl");
var isDarkTheme_1 = require("owa-theme/lib/utils/isDarkTheme");
var classnames = require('classnames');
var styles = require('./ChoiceGroupWithImages.scss');
var ChoiceItemWithImages = mobx_react_1.observer(function (props) {
    var option = props;
    return (React.createElement("div", { className: styles.option, style: { width: option.width + 4 + "px" } },
        React.createElement("span", { id: props.labelId, className: "ms-Label" }, props.text),
        React.createElement("div", { className: classnames(styles.imageContainer, 'flipForRtl', option.checked && styles.selected) },
            React.createElement(Image_1.Image, { src: url_1.resolve(getPackageBaseUrl_1.default(), option.imageUri), className: styles.image, alt: "", role: "presentation", style: 
                /* We need to invert the black SVG for dark themes. Does not work in IE11, but these SVGs will be going away with an option refactor soon anyway */
                isDarkTheme_1.default() ? { filter: 'invert(100%)' } : undefined }))));
});
var ChoiceGroupWithImages = /** @class */ (function (_super) {
    tslib_1.__extends(ChoiceGroupWithImages, _super);
    function ChoiceGroupWithImages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onRenderChoice = function (props) { return React.createElement(ChoiceItemWithImages, tslib_1.__assign({}, props)); };
        return _this;
    }
    ChoiceGroupWithImages.prototype.render = function () {
        var _this = this;
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, tslib_1.__assign({}, this.props, { className: classnames(this.props.className, styles.choiceGroup), options: this.props.options &&
                this.props.options.map(function (option) {
                    return (tslib_1.__assign({}, option, { onRenderLabel: _this.onRenderChoice }));
                }) })));
    };
    ChoiceGroupWithImages = tslib_1.__decorate([
        mobx_react_1.observer
    ], ChoiceGroupWithImages);
    return ChoiceGroupWithImages;
}(React.Component));
exports.default = ChoiceGroupWithImages;
//# sourceMappingURL=ChoiceGroupWithImages.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-choice-group-with-images/lib/components/ChoiceGroupWithImages.js
// module id = 5070
// module chunks = 2